var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#2C6BCC",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.836.336c4.144 0 7.5 3.356 7.5 7.5s-3.356 7.5-7.5 7.5-7.5-3.356-7.5-7.5 3.356-7.5 7.5-7.5zm-3.74 7.318c-.078.013-.135.147-.128.296.008.149.077.259.154.245h7.325c.038.001.074-.027.1-.078.027-.05.043-.12.043-.193 0-.073-.016-.141-.043-.192-.026-.05-.062-.08-.1-.078H4.122c-.008-.003-.017-.003-.026 0h0z",
    transform: "translate(-1299 -1241) translate(395 1162.5) translate(885 61.5) translate(20 18.216)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCircleIcon);
export default __webpack_public_path__ + "static/media/remove-circle-icon.fe81f024a7778760ccd63cd9cb679594.svg";
export { ForwardRef as ReactComponent };